import { get, omit, isEqual } from 'lodash';
function convertMinutesToHours(n) {
  var num = n;
  var hours = num / 60;
  var rhours = Math.floor(hours);
  var minutes = (hours - rhours) * 60;
  var rminutes = Math.round(minutes);
  return rhours + ' hr ' + rminutes + ' mins';
}

function getParsedCrudDataForClientAssociations(
  base,
  current,
  keyToCompare = 'id'
) {
  const addedItems = current.filter(
    (el) => !base.some((t) => get(t, keyToCompare) === get(el, keyToCompare))
  );
  const deletedItems = base.filter(
    (el) => !current.some((i) => get(i, keyToCompare) === get(el, keyToCompare))
  );
  const updatedItems = [];
  current.forEach((el) => {
    const index = base.findIndex(
      (t) => get(t, keyToCompare) === get(el, keyToCompare)
    );
    if (index > -1) {
      let baseId = base[index]?.id;
      el = omit(el, 'id');
      base[index] = omit(base[index], 'id');
      if (!isEqual(el, base[index]) && baseId) {
        updatedItems.push({
          id: baseId,
          client: el.client,
          site: el.site,
          primarySite: el.primarySite
        });
      }
    }
    return false;
  });
  return {
    addedItems,
    deletedItems,
    updatedItems
  };
}

export { convertMinutesToHours, getParsedCrudDataForClientAssociations };
